export default __webpack_public_path__ + "static/media/team3.e672e801.png";